import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const cameraPosition = atom<[number, number, number, number, number, number]>({
    key: 'cameraPosition',
    default: [0, 0.8, 5.2, -0.05, 0, 0],
});

const currentDefaultCameraPosition = atom<[number, number, number, number, number, number]>({
    key: 'defaultCameraPosition',
    default: [0, 0.8, 5.2, -0.05, 0, 0],
});

const currentConfiguratorOpenedCameraPosition = atom<[number, number, number, number, number, number]>({
    key: 'configuratorOpenedCameraPosition',
    default: [0.9, 0.8, 5.7, -0.05, 0, 0],
});

export const useCameraPositionValue = () => useRecoilValue(cameraPosition);
export const useSetCameraPosition = () => useSetRecoilState(cameraPosition);

export const useDefaultCameraPositionValue = () => useRecoilValue(currentDefaultCameraPosition);
export const useSetDefaultCameraPosition = () => useSetRecoilState(currentDefaultCameraPosition);

export const useConfiguratorOpenedCameraPositionValue = () => useRecoilValue(currentConfiguratorOpenedCameraPosition);
export const useSetConfiguratorOpenedCameraPosition = () => useSetRecoilState(currentConfiguratorOpenedCameraPosition);
